// @flow
import React from 'react';
import { Button } from '@elements';
import { APP_STORE_SUBSCRIPTIONS_URL, openExternal } from './PlanSummary';

// For whoever pays through the App Store, on the web and Android (never in the iOS app: App Review
// forbids pointing to another way to pay there): how to move the subscription to the Doutore.
// The API only lets an account subscribe on the web once its App Store subscription is over.
const AppStoreSwitch = ({ _ }: { _: Function }) => (
  <section className="appStoreSwitch">
    <h2>{_('switch/title')}</h2>
    <p>{_('switch/why')}</p>
    <ol>
      <li>
        <b>{_('switch/step1_title')}</b>
        <span>{_('switch/step1_text')}</span>
        <Button text={_('switch/step1_button')} onClick={() => openExternal(APP_STORE_SUBSCRIPTIONS_URL)} />
      </li>
      <li>
        <b>{_('switch/step2_title')}</b>
        <span>{_('switch/step2_text')}</span>
        <Button className="appStoreSwitch-link" text={_('switch/step2_support')} intercom />
      </li>
    </ol>
  </section>
);

export default AppStoreSwitch;
